var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSimplicityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 79,
    viewBox: "0 0 78 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.0577 57.5882C31.1338 59.8375 28.6751 61.5667 25.9078 62.6168C23.1405 63.6669 20.1535 64.004 17.2218 63.5973C14.2901 63.1905 11.5077 62.0528 9.13085 60.289C6.75399 58.5252 4.85894 56.1919 3.62011 53.5038C2.38128 50.8157 1.83846 47.8592 2.04162 44.9064C2.24478 41.9535 3.18739 39.0992 4.78269 36.6061C6.37799 34.113 8.57475 32.0612 11.1708 30.6396C13.7668 29.2179 16.6787 28.472 19.6385 28.4706C21.0245 28.4778 22.4054 28.6381 23.7562 28.9485C22.0121 26.1607 21.0943 22.9355 21.1091 19.6471C21.1091 14.9668 22.9684 10.4782 26.2778 7.1687C29.5873 3.85924 34.0759 2 38.7562 2C43.4365 2 47.9251 3.85924 51.2346 7.1687C54.544 10.4782 56.4033 14.9668 56.4033 19.6471C56.4181 22.9355 55.5003 26.1607 53.7562 28.9485C55.107 28.6381 56.4879 28.4778 57.8738 28.4706C60.8337 28.472 63.7456 29.2179 66.3416 30.6396C68.9377 32.0612 71.1344 34.113 72.7297 36.6061C74.325 39.0992 75.2676 41.9535 75.4708 44.9064C75.6739 47.8592 75.1311 50.8157 73.8923 53.5038C72.6535 56.1919 70.7584 58.5252 68.3815 60.289C66.0047 62.0528 63.2223 63.1905 60.2906 63.5973C57.3589 64.004 54.3719 63.6669 51.6046 62.6168C48.8373 61.5667 46.3786 59.8375 44.4547 57.5882L50.5209 77H26.9915L33.0577 57.5882Z",
    stroke: "url(#paint0_linear_554_1450)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_554_1450",
    x1: 38.7562,
    y1: 2,
    x2: 38.7562,
    y2: 77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EAFF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#4063B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#704BA5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimplicityIcon);
export default __webpack_public_path__ + "static/media/simplicity_icon.1c8136554328cf9acf4b4f11bcb7c310.svg";
export { ForwardRef as ReactComponent };